import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the extras box; each part uses its own slice of it */
import styles from './ServiceExtras.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The service dot on the file (design se.css .se-mk). */
export type ExtraFileMark = 'youtube' | 'soundcloud';

interface ExtraFileThumbProps {
  /** `wide`: a 16:9 video. `square`: a song or an artwork. */
  shape: 'wide' | 'square';
  /** The poster or the cover; none: the plain ground. */
  image?: string | null;
  /** No file yet: a dashed box (design a1 "noVideo", "noMaster"). */
  empty?: boolean;
  /** The service is not connected (design a1 "notConnected"). */
  dim?: boolean;
  mark?: ExtraFileMark | null;
}

const MARK_CLASS: Record<ExtraFileMark, string | undefined> = {
  youtube: styles.markYouTube,
  soundcloud: styles.markSoundCloud,
};

/** The small file picture in the first column of an extras item (design service-extras a1 .se-th). */
const ExtraFileThumbComponent: React.FC<ExtraFileThumbProps> = ({ shape, image, empty, dim, mark }) => {
  const isEmpty = empty === true;
  return (
    <span
      className={clsx(
        styles.file,
        shape === 'wide' ? styles.fileWide : styles.fileSquare,
        isEmpty && styles.fileEmpty,
        dim === true && styles.fileDim
      )}
      style={isEmpty || image === undefined || image === null ? undefined : { backgroundImage: `url(${image})` }}
      aria-hidden="true"
    >
      {!isEmpty && mark !== undefined && mark !== null && <i className={clsx(styles.fileMark, MARK_CLASS[mark])} />}
    </span>
  );
};

export const ExtraFileThumb = TypedMemo(ExtraFileThumbComponent);
